// ============================================================================
// SPANISH TRANSLATIONS - UI
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'es',
    languageName: 'Español',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Crónicas\ndel Amor",
    subtitle: "Descubrimiento interactivo de las Escrituras",
    tagline: "Caminando hacia la luz divina",
    menu: "Menú",
    retry: "Reintentar"
  },
  
  buttons: {
    play: "JUGAR",
    back: "Atrás",
    continue: "Continuar",
    restart: "Reiniciar",
    close: "Cerrar",
    nextLevel: "Siguiente Nivel",
    selectLevel: "Selección de Niveles",
    retry: "Reintentar",
    mainMenu: "Menú Principal",
    start: "Comenzar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    save: "Guardar",
    load: "Cargar",
    yesRestart: "Sí, reiniciar",
    noContinue: "No, continuar",
    tryAgain: "Intentar de nuevo",
    backToMenu: "Volver al menú"
  },
  
  labels: {
    score: "Puntuación",
    stars: "Estrellas",
    wisdom: "Sabiduría",
    revelation: "Revelación",
    lives: "Vidas",
    combo: "Combo",
    level: "NIVEL",
    easy: "FÁCIL",
    medium: "MEDIO",
    hard: "DIFÍCIL",
    correct: "Correcto!",
    gameOver: "Prueba Fallida",
    victory: "Victoria!",
    completed: "Completado",
    rank: "Rango Espiritual",
    points: "Puntos de Sabiduría",
    unlockedLevels: "nivel(es) desbloqueado(s)",
    questionOfKnowledge: "Pregunta de Conocimiento",
    hintOfWisdom: "Pista de Sabiduría",
    knowledgeMastered: "Conocimiento Dominado!",
    knowledgeAcquired: "Conocimiento adquirido!",
    testFailed: "Prueba Fallida",
    wisdomBonus: "Bonificación",
    xpGained: "XP",
    newRank: "Nuevo rango",
    nextGrade: "Próximo grado",
    maxLevelReached: "Nivel máximo alcanzado!",
    wrongAnswer: "¡Respuesta incorrecta!"
  },
  
  menu: {
    playButton: "JUGAR",
    info: "Info",
    treasures: "Tesoros",
    john: "Juan",
    reset: "Resetear",
    restart: " Reiniciar aventura?",
    confirmReset: "Estás seguro de que quieres borrar todo tu progreso?",
    youWillLose: "Perderás:",
    wisdomPoints: "Puntos de Sabiduría",
    starsCollected: "estrellas recolectadas",
    levelsUnlocked: "nivel(es) desbloqueado(s)",
    spiritualRank: "Rango Espiritual",
    newAdventure: " Nueva Aventura",
    readyToStart: "Listo para comenzar?",
    startJourney: "Comienza tu viaje en el conocimiento de las Escrituras!",
    audioControls: "Controles de audio",
    mute: "Silenciar sonido",
    unmute: "Activar sonido",
    close: "Cerrar",
    language: "Idioma",
    restartGame: "Reiniciar juego"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Aventura bíblica interactiva",
    anonymousMode: "Jugar Anónimo",
    anonymousDesc: "Elige un nombre de usuario",
    emailMode: "Inicio de sesión por Email",
    emailDesc: "Guardado multi-dispositivo",
    pseudo: "Nombre de usuario",
    pseudoPlaceholder: "Tu nombre de usuario...",
    email: "Dirección de Email",
    emailPlaceholder: "tu@email.com",
    startPlaying: "Comenzar a jugar",
    sendLink: "Enviar enlace",
    sending: "Enviando...",
    connecting: "Conectando...",
    back: "Atrás",
    localSave: "Tu progreso se guardará localmente",
    cloudSync: "Sin contraseña requerida  Sincronización en la nube",
    magicLink: "Recibe un enlace mágico por email",
    checkEmail: " Revisa tu email! Se te ha enviado un enlace de inicio de sesión.",
    checkSpam: "Revisa también tu carpeta de spam/correo no deseado",
    waitingConnection: "Esperando conexión...",
    errorSend: "Error al enviar el enlace",
    rateLimited: "⏳ Por favor espere 15 segundos antes de reenviar un email",
    importSession: "🔄 Importar sesión desde producción",
    errorConnection: "Error de conexión",
    enterPseudo: "Por favor ingresa un nombre de usuario",
    enterEmail: "Por favor ingresa un email válido",
    // Tooltips
    never: "Nunca",
    save: "Guardar partida",
    lastSave: "última",
    refresh: "Recargar progreso",
    logout: "Cerrar sesión",
    connectToCloud: "Conectarse para guardar en línea",
    editPseudo: "Editar usuario",
    confirm: "Confirmar",
    cancel: "Cancelar",
    close: "Cerrar",
    passwordMode: "Conexión Simple",
    passwordDesc: "Email + contraseña",
    password: "Contraseña",
    passwordPlaceholder: "Mínimo 6 caracteres",
    passwordMinLength: "Mínimo 6 caracteres",
    playWithoutAccount: "Jugar sin cuenta",
    forgotPassword: "¿Olvidaste tu contraseña?",
    resetPasswordTitle: "Restablecer Contraseña",
    resetPasswordSubtitle: "Ingresa tu correo para recibir un enlace de restablecimiento",
    sendResetLink: "Enviar Enlace",
    resetEmailSent: "📧 ¡Correo de restablecimiento enviado! Revisa tu bandeja de entrada.",
    errorReset: "Error al enviar el correo",
    backToSignin: "Volver a Iniciar Sesión",
    newPassword: "Nueva Contraseña",
    enterNewPassword: "Elige una nueva contraseña segura",
    confirmPassword: "Confirmar Contraseña",
    updatePassword: "Actualizar Contraseña",
    passwordsDontMatch: "Las contraseñas no coinciden",
    passwordUpdateSuccess: "✅ ¡Contraseña actualizada con éxito!",
    errorUpdatePassword: "Error al actualizar la contraseña",
    resetLinkExpired: "Enlace de restablecimiento caducado o inválido",
    forgotPassword: "¿Olvidaste tu contraseña?",
    signup: "Registrarse",
    signin: "Iniciar Sesión",
    createAccount: "Crear Cuenta",
    signupInfo: "Complete el formulario a continuación",
    passwordInfo: "Acceso rápido con contraseña",
    signupButton: "Crear Mi Cuenta",
    signinButton: "Iniciar Sesión",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
    emailAlreadyExists: "Este correo ya está en uso",
    emailExistsHint: "✉️ Este correo ya está registrado. ¡Intenta iniciar sesión! (¿Quizás creado desde otro juego?)",
    switchToSignin: "🔑 Cambia al modo Iniciar Sesión con tu correo existente",
    invalidCredentials: "Correo o contraseña incorrectos",
    signupSuccess: "📧 ¡Cuenta creada! Revisa tu email para confirmar tu registro.",
    emailConfirmationRequired: "Verifica tu email",
    checkSpamFolder: "Revisa también spam",
    connectionSuccess: "✅ Conexión exitosa!",
    errorSignup: "Error al registrarse"},
  
  install: {
    title: "Instalar la aplicación",
    subtitle: "Acceso rápido y sin conexión",
    feature1: "Lanzamiento instantáneo desde tu pantalla de inicio",
    feature2: "Funciona sin conexión después de la instalación",
    feature3: "Experiencia de aplicación nativa",
    feature4: "No se requiere descarga de tienda",
    install: "Instalar",
    dismiss: "Más tarde",
    info: "Puedes desinstalar la aplicación en cualquier momento"
  },
  
  ranks: {
    seeker: "Buscador",
    believer: "El Despertado",
    disciple: "Discípulo",
    servant: "Servidor",
    witness: "Testigo",
    guardian: "Guardián",
    wise: "Sabio",
    prophet: "Profeta",
    apostle: "Apóstol",
    seekerDesc: "Inicio del viaje espiritual",
    believerDesc: "Conciencia espiritual despertada",
    discipleDesc: "Aprendizaje de las enseñanzas",
    servantDesc: "Servicio y devoción",
    witnessDesc: "Compartir la fe",
    guardianDesc: "Protección de la verdad",
    wiseDesc: "Sabiduría y conocimiento",
    prophetDesc: "Visión espiritual",
    apostleDesc: "Maestro espiritual"
  },

  spiritualJourney: {
    beginning: "Inicio del viaje espiritual",
    progress: "Progreso espiritual",
    grade: "Grado",
    xp: "XP",
    level: "Nivel",
    nextGrade: "Siguiente grado",
    still: "Aún",
    maxLevelReached: "¡Nivel Máximo Alcanzado!",
    masteredAllTeachings: "Has dominado todas las enseñanzas",
    progression: "Progresión"
  },
  
  treasures: {
    title: "📖 Tesoros de la Biblia",
    verse: "Versículo del día",
    fact: "Sabías que?",
    treasure: "🎁 Tesoro oculto",
    question: "Pregunta divertida",
    newTreasure: "Nuevo tesoro",
    context: "Contexto",
    strongReference: "Referencia bíblica para estudio profundo",
    johnGospelDescription: "El Evangelio de Juan revela la divinidad de Jesús a través de 21 Capítulos inspiradores.",
    availableInLanguages: "Disponible en 14 idiomas",
    johnGospelTitle: "Evangelio de Juan",
    johnGospelStats: "21 capítulos • 878 versículos • 14 idiomas",
    bibleReaderStrong: "Lector Bíblico + Strong",
    bibleReaderStrongDesc: "Lectura completa con diccionario Strong",
    johnTreasures: "Tesoros de Juan",
    johnTreasuresDesc: "Tesoros bíblicos y hechos interesantes",
    johnBibleReader: "Lector de la Biblia Juan + Strong",
    emmanuelMemo: "Memo de Emmanuel",
    emmanuelMessage: "Has llegado a la cima de la montaña, y el conocimiento está adquirido. Pero la fe inquebrantable requiere experiencia de vida, misericordia y verdadero amor de Jesús. Las diversas pruebas de la vida pondrán a prueba tu camino, el verdadero camino que elegimos, nuestro corazón. Permanecemos imperfectos, nuestros deseos son muchos, y el amor por la ganancia o la comodidad personal se convierte demasiado a menudo en nuestra prioridad egoísta. Pide a Dios sabiduría, su amor, su fuerza, y reconoce humildemente tus debilidades, porque no podemos ocultarle nada... Nada. No es necesario navegar en modo privado, usar VPN o incluso borrar el historial. Ayuna como Daniel: prívate por un momento de lo que más amas, en calma y sabiduría. Esto te permitirá escuchar mejor a Dios, tener una disposición del corazón lista para transformaciones profundas  y a menudo dolorosas. Entonces los sueños y las visiones se volverán más claros, como con José. Pero guárdate del orgullo: no cedas al 'siempre tengo razón' o 'sé mejor'. Porque la revelación de Dios es una gracia extraordinaria. No te conviertas en un maestro de la Ley, capaz de crucificar a Jesús nuevamente hoy, Él quien simplemente pide amar a tu prójimo... y otorgarles la misma libertad que tú recibes. Tener fe significa entrar en una relación y un viaje libre del corazón. Te convertirá en héroes poderosos, capaces de lo imposible. Porque la experiencia de lo sobrenatural, la presencia de Dios, Su confirmación o bendición te hará verdaderamente inquebrantable.",
    clarification: "Aclaración importante",
    bibleOffline: "Leer la Biblia Sin conexión",
    bibleStudy: "📖 Estudio bíblico",
    version: "Versión",
    openReader: "Abrir lector",
    features: "Características"
  },
  
  messages: {
    chooseCard: " Elige tu carta de poder",
    cardHelp: "Te acompañará durante las 3 preguntas de este nivel",
    chooseAnswer: " Elige tu respuesta:",
    wrongAnswer: " Respuesta incorrecta! Te quedan {lives} vida(s). Inténtalo de nuevo!",
    levelCompleted: "Nivel {level} Completado",
    questionsProgress: "Pregunta {current} de {total}",
    starsCollected: "Estrellas recolectadas: {current}/{total}",
    pointsEarned: "+{points} Puntos de Sabiduría",
    secondChance: " Tu carta CORAJE te da una segunda oportunidad! Inténtalo de nuevo con sabiduría.",
    bonusApplied: " Bonificación {card}: +{percent}% ({base}  {final})",
    defeatedQuote: "Todo lo puedo en Él que me fortalece",
    perfect: " Perfecto",
    good: " Bien",
    start: " Inicio",
    secretLevel: " NIVEL SECRETO DESBLOQUEADO!",
    secretChapter: " Capítulo Secreto",
    returnToLevels: "Volver",
    next: "Siguiente",
    retry: "Reintentar",
    menu: "Menú",
    chapter: "Capítulo",
    chapterStars: "Estrellas del Capítulo",
    totalGlobal: "Total global",
    backToMenu: "Volver al Menú"
  },
  
  chapters: {
    "1": "Génesis",
    "2": "Éxodo",
    "3": "Jesucristo",
    "4": "Crucifixión/Resurrección",
    "5": "Iglesia Primitiva",
    "6": "Misiones de Pablo",
    "7": "Cartas/Apocalipsis",
    "8": "Nivel Extra"
  },
  
  cards: {
    faith: "FE",
    courage: "CORAJE",
    wisdom: "SABIDURÍA",
    faithKnowledge: "+50% puntos",
    courageKnowledge: "Segunda oportunidad",
    wisdomKnowledge: "Pista + Bonificación",
    faithDesc: "Máximos puntos de sabiduría obtenidos",
    courageDesc: "Puntos normales pero segunda oportunidad",
    wisdomDesc: "Pista revelada y +25% puntos",
    chooseCard: "🃏 Elige un don de conocimiento",
    cardEffects: "🃏 Efectos de los dones de conocimiento:",
    faithEffect: "+50% puntos de sabiduría - Recompensa máxima",
    courageEffect: "Puntos normales pero segunda oportunidad en error",
    wisdomEffect: "+25% puntos + pista revelada para cada pregunta",
    chooseWisely: "Elige sabiamente, ya que tu elección te acompañará durante todo el nivel"
  },
  
  challenge: {
    loading: "Cargando nivel...",
    peace: " Que la paz descanse en tu casa",
    questionsAwaiting: " 3 preguntas de conocimiento te esperan",
    starsQuote: "Cada estrella es un paso hacia la luz divina"
  },
  
  info: {
    title: "Unity Quest Crónicas de Paz",
    subtitle: "Descubrimiento interactivo de las Escrituras",
    yourStats: "Tus Estadísticas",
    score: "Puntuación",
    wisdom: "Sabiduría",
    revelation: "Revelación",
    createdWith: "Creado con ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "Desarrollador apasionado por la espiritualidad",
    artistModule: "Emmanuel Artista",
    artistPortfolio: "Portafolio artístico y creaciones digitales",
    features: "Características",
    multipleChapters: "91 niveles distribuidos en 8 capítulos bíblicos",
    powerCards: "3 cartas de poder únicas (Fe, Coraje, Sabiduría)",
    progressionSystem: "Sistema de progresión con rangos espirituales",
    bibleTreasures: "Tesoros bíblicos y datos interesantes",
    howToPlay: "Cómo Jugar",
    selectLevel: "Selecciona un nivel desbloqueado",
    choosePowerCard: "Elige tu carta de poder",
    answerQuestions: "Responde las 3 preguntas de conocimiento",
    earnStars: "Gana estrellas según las vidas restantes",
    tips: "Consejos",
    readCarefully: "Lee cada pregunta cuidadosamente",
    useWisdomCard: "Usa la carta Sabiduría para pistas",
    courageGivesSecondChance: "La carta Coraje te da una segunda oportunidad",
    faithMaximizes: "La carta Fe maximiza tus puntos",
    johnGospelTitle: "Evangelio de Juan",
    johnGospelStats: "21 capítulos • 878 versículos • 14 idiomas",
    bibleReaderStrong: "Lector Bíblico + Strong",
    bibleReaderStrongDesc: "Lectura completa con diccionario Strong",
    johnTreasures: "Tesoros de Juan",
    johnTreasuresDesc: "Tesoros bíblicos y hechos interesantes",
    quickAccessChapters: "Acceso rápido a capítulos famosos:",
    johnChapter1: "Prólogo",
    johnChapter3: "Nacer de nuevo",
    johnChapter14: "Yo soy el camino",
    johnChapter20: "Resurrección",
    version: "Versión",
    madeWithLove: "Hecho con amor para la gloria de Dios",
    backToMenu: "Volver al Menú"
  },
  
  bible: {
    readerTitle: "📖 Lector de la Biblia",
    johnReaderTitle: "Lector de la Biblia - Evangelio de Juan",
    john: "Juan",
    loading: "Cargando las Escrituras...",
    loadingChapter: "Capítulo {chapter} del Evangelio de Juan. Los datos completos se están cargando...",
    exploreWhileLoading: "Mientras tanto, puede explorar otros capítulos o usar la función de búsqueda.",
    menu: "Menú",
    tabBible: "Biblia",
    tabUnity: "Unidad",
    strong: "Strong",
    strongReferences: "Referencias Strong",
    verses: "Versículos",
    previous: "Anterior",
    next: "Siguiente",
    strongDefinition: "Referencia Strong",
    word: "Palabra original",
    transliteration: "Transliteración",
    close: "Cerrar",
    share: "Compartir",
    shareVerse: "Compartir este Versículo",
    shareSelection: "Compartir Selección",
    pronunciation: "Pronunciación",
    meaning: "Significado",
    definition: "Definición completa",
    usage: "Uso bíblico",
    etymology: "Etimología",
    search: "Buscar...",
    definitionNotFound: "Definición no encontrada",
    definitionLoading: "Definición por cargar...",
    imageFeatureComing: " Función de imagen próximamente!",
    copyError: "Error al copiar:",
    error: " Error",
    errorLoading: "Error de carga",
    retry: "Reintentar",
    readerInDevelopment: "Lector de la Biblia de Juan en desarrollo...",
    verseCopied: "Versículo copiado al portapapeles!",
    moreReferences: "y {{count}} otras referencias",
    copyright: "📖 Dominio público • Strong",
    markAsRead: "Pasaje leído",
    alreadyRead: "Ya leído",
    readingBonus: "Bonificación de lectura",
    results: "resultados",
    result: "resultado",
    copy: "Copiar",
    image: "Imagen"
  },
  
  bibleResources: {
    inAppReader: {
      name: "Leer en la App",
      description: "Lector de Biblia integrado con Strong",
      features: {
        offline: "Sin conexión",
        strong: "Números Strong",
        navigation: "Navegación"
      }
    }
  },
  
  mountain: {
    spiritualAscension: "Ascensión Espiritual",
    levelProgress: "Nivel {{level}}  {{stars}} estrellas obtenidas",
    combo: "Combo",
    perfectMessage: "\"Porque mis pensamientos no son vuestros pensamientos\" - El cordero sube hacia la sabiduría perfecta",
    goodMessage: "\"Buscad y encontraréis\" - La ascensión continúa hacia la verdad",
    startMessage: "\"La fe, aunque pequeña como un grano de mostaza\" - Primer paso hacia la luz",
    skipAnimation: "Saltar animación",
    chapter: "Capítulo",
    chapterProgress: "Capítulo {{current}}/{{total}}",
    secret: "Secreto",
    waypoints: {
      start: "Inicio",
      firstSlope: "Primera pendiente",
      lastSlope: "Última pendiente"
    },
    status: {
      defeat: "Derrota",
      inProgress: "En progreso"
    }
  },
  
  quotes: {
    wisdom: "El verdadero conocimiento conduce a la sabiduría eterna",
    faith: "Todo lo puedo en Cristo que me fortalece",
    hope: "El Señor es mi pastor, nada me faltará",
    love: "Porque de tal manera amó Dios al mundo...",
    perseverance: "La fe requiere perseverancia",
    defeat: "El fracaso invita a crecer en conocimiento"
  },

  philosophy: {
    title: "Dimensión filosófica",
    loveOntology: "El amor como principio ontológico",
    loveDescription: "Jesús transforma el amor en fundamento metafásico: amar a Dios y al prójimo se convierte en la estructura misma del ser auténtico. El amor trasciende la moral para convertirse en modo de existencia.",
    newCommandment: "El Nuevo Mandamiento",
    jesusEmphasizes: "Cuando Jesús da un nuevo mandamiento, enfatiza el verbo amar",
    loveGod: "Ama a Dios con todo tu corazón",
    loveNeighbor: "Ama a tu prójimo como a ti mismo",
    lovePriority: "El amor se convierte en una prioridad"
  },

  unity: unityTranslations,

  footer: {
    version: "Versión 1.0  2024",
    dedication: "Desarrollado para la gloria de Dios"
  },

  endCredits: {
    lines: [
      { text: "Has llegado a la cima de la montaña", delay: 2000 },
      { text: "Has aprendido muchas cosas", delay: 2000 },
      { text: "Tu fe crece cada día", delay: 2000 },
      { text: "Vives cosas hermosas con Dios", delay: 2000 },
      { text: "Las dificultades te ayudan a crecer", delay: 2000 },
      { text: "Ellas muestran lo que es importante", delay: 2000 },
      { text: "Sé humilde como un niño pequeño", delay: 2000 },
      { text: "Dios ama tu corazón simple", delay: 2000 },
      { text: "En el silencio escuchas a Dios", delay: 2000 },
      { text: "El ayuno libera tu espáritu", delay: 2000 },
      { text: "Ora y Dios te guiará", delay: 2000 },
      { text: "El orgullo oculta la verdad", delay: 2000 },
      { text: "La gracia de Dios es magnáfica", delay: 2000 },
      { text: "Viene del corazón de Dios", delay: 2000 },
      { text: "La verdadera fe te hace libre", delay: 2000 },
      { text: "Te une a Dios para siempre", delay: 2000 },
      { text: "El amor puede cambiarlo todo", delay: 2000 },
      { text: "Puede hacer milagros", delay: 2000 },
      { text: "Repite conmigo", delay: 2000 },
      { text: "Jesús, te doy mi corazón", delay: 3000 },
      { text: "Eres mi rey, mi salvador", delay: 3000 },
      { text: "Ven a transformar mi vida", delay: 3000 },
      { text: "El camino continúa ahora", delay: 2000 },
      { text: "Comparte esta hermosa luz", delay: 2000 },
      { text: "Hacia la vida que nunca termina", delay: 2000 },
      { text: "Guarda el amor en tu corazón", delay: 3000 },
      { text: "Como un tesoro precioso", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "BRAVO!",
      proud: "ESTAMOS ORGULLOSOS DE TI",
      courage: "CORAJE VALEROSO",
      peace: "PORTADOR DE PAZ",
      child: "HIJO DE DIOS",
      blessing: "QUE DIOS TE BENDIGA",
      continue: "Continuar"
    }
  },

  validation: {
    pseudoTooShort: "El nombre de usuario debe contener al menos 2 caracteres",
    enterPseudo: "Por favor ingresa un nombre de usuario"
  },

  pseudoSetup: {
    title: "Elige tu nombre de usuario de jugador",
    profileConfig: "Configuración del Perfil",
    connectedWith: "Conectado con",
    playerPseudo: "Nombre de Usuario de Jugador",
    pseudoPlaceholder: "Tu nombre de usuario...",
    pseudoRequirements: "2-20 caracteres  Mostrado en clasificaciones",
    suggestions: "Sugerencias",
    confirm: "Confirmar Nombre de Usuario",
    errorConfig: "Error durante la configuración"
  },

  navigation: {
    back: "Atrás"
  },

  console: {
    starsUnlocked: "estrellas alcanzadas! Desbloqueo de Capítulo",
    defeatAnimation: "Derrota... J.C. desciende"
  },

  errors: {
    progressionError: "Error de progresión",
    invalidProgressionData: "Datos de progresión inválidos:"
  },

  levels: {
    chaptersAndBonus: "8 Capítulos + nivel extra",
    bonusUnlocked: " NIVEL EXTRA DESBLOQUEADO! Has alcanzado la perfección espiritual!",
    starsToDiscover: "273 {stars} por descubrir",
    starsPerLevel: "3 {stars} por nivel"
  },

  architecture: {
    title: " Arquitectura técnica",
    react: {
      name: "React",
      description: "Interfaz moderna"
    },
    modules: {
      name: "Módulos",
      description: "Carga dinámica"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Guardado local"
    },
    tailwind: {
      name: "Tailwind",
      description: "Diseño responsive"
    }
  },

  gameManager: {
    title: "Guardado de juego",
    saveLocal: "Guardado local",
    saveCloud: "Nube sincronizada",
    saveWaiting: "Esperando conexión",
    lastSave: "Último guardado:",
    never: "Nunca",
    saving: "Guardando...",
    save: "Guardar",
    loadProgress: "Cargar",
    loading: "Cargando...",
    autoSaveEnabled: " Guardado automático activado",
    saveError: " Error de guardado",
    gameSaved: " Partida guardada!",
    gameLoaded: " Partida cargada!"
  }
};

export default uiTranslations;
